import styled from 'styled-components';
import { pStyles } from 'utils/resuable-css';
import { deviceBreakpoints, variables } from 'variables';

export const NewMacroStep4SC = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.pageBackgroundColor};
  padding: ${variables.pageContentPadding}px;
  padding-top: 70px;
  width: 100%;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
`;

export const StepDescription = styled.div`
  margin-top: 40px;
  font-size: ${(props) => props.theme.default?.p};
  ${(props) => pStyles(props.theme.resolutions)};
  line-height: 26px;
  @media only screen and (max-width: ${deviceBreakpoints.phone}px) {
    width: 90%;
  }
`;

export const SubmitReply = styled.div`
  margin-top: 1em;
  margin-bottom: 2em;
  max-width: 800px;
  width: 100%;
  @media only screen and (max-width: 960px) {
    width: 100%;
  }
`;
